<template>
  <div>
    <b-form-group id="full-name" :label="$t($getConst.pages.personalDetails.full_name)" label-for="full-name-input">
      <b-form-input
        id="full-name-input"
        :value="firstName + ' ' + lastName"
        disabled
        class="text-capitalize"
        size="lg"
        required
      ></b-form-input>
    </b-form-group>
    <b-form-group id="language" :label="$t(this.$getConst.pages.personalDetails.preferredLanguage)" label-for="language-input">
      <multiselect
        v-model="$v.form.language.$model"
        :class="{ 'is-invalid': $v.form.language.$error }"
        track-by="id"
        :allowEmpty="false"
        openDirection="bottom"
        label="name"
        :placeholder="$t(this.$getConst.pages.form.select_option)"
        :options="languages"
        @input="changeLanguage"
      >
        <template slot="singleLabel" slot-scope="props">
          <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
          {{$t(props.option.name) | capitalize}}
        </template>
        <template slot="option" slot-scope="props">
          <lang-flag :iso="props.option.code" :squared="false" class="mr-2"/>
          {{$t(props.option.name.toLowerCase()) | capitalize}}
        </template>
      </multiselect>
      <AppFormFeedback :errors="$v.form.language"/>
    </b-form-group>
  </div>
</template>

<script>
  import {required} from "vuelidate/lib/validators";
  import {getAllLanguagesForConnectedScope} from "../../api/languages.api";
  import jwtDecode from "jwt-decode";
  import AppFormFeedback from "../../components/common/form/AppFormFeedback";

  export default {
    name: "StepOne",
    components: {AppFormFeedback},
    data() {
      return {
        firstName: null,
        lastName: null,
        languages: [],
        tokenDecoded: null,
        form: {
          language: null,
        }
      }
    },
    validations: {
      form: {
        language: {required}
      }
    },
    methods: {
      changeLanguage() {
        this.$i18n.locale = this.form.language.code;
      },
      getAllLanguages() {
        getAllLanguagesForConnectedScope().then(
          (response) => {
            this.languages = response.data;
            this.initDefaultLanguage();
          },
          (error) => {
            this.handleApiError(error);
          }
        )
      },
      initDefaultLanguage() {
        this.form.language = this.languages.find(element => element.id === this.tokenDecoded.language_id);
        this.changeLanguage();
      },
      getDataFromToken() {
        this.tokenDecoded = jwtDecode(this.$route.query.token_hint);
        this.firstName = this.tokenDecoded.firstName;
        this.lastName = this.tokenDecoded.lastName;
      },
    },
    watch: {
      $v: {
        handler: function (val) {
          if(!val.$invalid) {
            this.$store.dispatch("signup/setFirstStep", this.form.language);
            this.$emit('can-continue', {value: true});
          } else {
            this.$emit('can-continue', {value: false});
          }
        },
        deep: true
      },
      clickedNext(val) {
        if(val === true) {
          this.$v.form.$touch();
        }
      }
    },
    async mounted() {
      await this.getDataFromToken();
      await this.getAllLanguages();
      if(!this.$v.$invalid) {
        this.$store.dispatch("signup/setFirstStep", this.form.language);
        this.$emit('can-continue', {value: true});
      } else {
        this.$emit('can-continue', {value: false});
      }
    }
  }
</script>

<style scoped>

</style>
